import {
    Button,
    Drawer,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@material-ui/core";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { PopupNotification } from "components/PopupNotification/PopupNotification";
import ThorPagination from "components/ThorPagination/ThorPagination";
import { observer } from "mobx-react";
import { ChangeEvent, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useStore } from "store/StoreConfigs";
import AddGroupForm from "./AddGroupForm";
import { userManagementStyles } from "./userManagementStyles";

export default observer(function GroupsTab() {
    const classes = userManagementStyles();
    const { groupStore, identityStore } = useStore();
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        groupStore.loadGroups();
    }, [groupStore.currentPage]);

    useEffect(() => {
        groupStore.clearPagination();
        groupStore.loadGroups();
    }, [groupStore.selectedCustomer]);

    if (groupStore.groupsLoading) {
        return (
            <div style={{ maxHeight: "300px", maxWidth: "300px" }}>
                <LoadingIndicator />
            </div>
        );
    }

    const closeDrawer = () => setDrawerOpen(false);
    const openDrawer = () => setDrawerOpen(true);

    const handleCustomerChange = (event: ChangeEvent<{ name?: string; value: unknown }>) => {
        groupStore.setSelectedCustomerByName(event.target.value as string);
    };

    const successCallback = ({ groupName, customerName }: any) => {
        let id: string | number = "";

        const handlePopupClose = () => {
            toast.dismiss(id);
        };

        closeDrawer();

        id = toast(
            <PopupNotification
                type="success"
                title={`Group '${groupName}' added successfully`}
                closeCallback={handlePopupClose}
            />
        );

        if (customerName === groupStore.selectedCustomer?.name) {
            groupStore.clearPagination();
            groupStore.loadGroups();
        }
    };

    return (
        <div>
            <Button className={classes.addButton} onClick={openDrawer}>
                Add Group
            </Button>

            {drawerOpen && (
                <>
                    <Drawer anchor="right" open={drawerOpen} onClose={closeDrawer}>
                        <AddGroupForm successCallback={successCallback} />
                    </Drawer>
                </>
            )}

            {identityStore.isGlobalUser && (
                <FormControl variant="outlined" className={classes.customerDropdown}>
                    <InputLabel id="selected-customer-label">Customer</InputLabel>
                    <Select
                        labelId="selected-customer-label"
                        id="selected-customer-input"
                        value={groupStore.selectedCustomer ? groupStore.selectedCustomer.name : "-- global --"}
                        onChange={handleCustomerChange}
                        label="Customer"
                    >
                        <MenuItem value="-- global --">
                            <em>-- global --</em>
                        </MenuItem>
                        {identityStore.allCustomers.map((x) => (
                            <MenuItem key={x.id} value={x.name}>
                                {x.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Id</TableCell>
                            <TableCell>Name</TableCell>
                            {groupStore.selectedCustomer && <TableCell>Module</TableCell>}
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {groupStore.groups.map((group) => (
                            <TableRow key={group.id}>
                                <TableCell>{group.id}</TableCell>
                                <TableCell>{group.name}</TableCell>
                                {groupStore.selectedCustomer && <TableCell>{group.moduleName}</TableCell>}
                                <TableCell>
                                    <Button>Edit</Button>
                                    <Button>Delete</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <ThorPagination
                page={groupStore.currentPage}
                pages={groupStore.totalPages}
                onPageChange={groupStore.movePage}
                isLastPage={groupStore.isLastPage}
                setPage={groupStore.setPage}
            />
        </div>
    );
});
